package frontend.lib

import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.internal.JSJoda.DateTimeFormatter
import kotlinx.datetime.toLocalDateTime
import net.sergeych.sprintf.sprintf
import wrappers.isValidChecksumAddress
import org.jetbrains.compose.web.attributes.AttrsBuilder
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.attributes.AttrsScopeBuilder
import org.w3c.dom.*

private val hexArray = "0123456789ABCDEF".toCharArray()

fun isETHAddress(addr: String): Boolean {
    if (!addr.startsWith(("0x"))) return false
    return isValidChecksumAddress(addr)
}

fun textToHex(text: String): String {
    return bytesToHex(text.encodeToByteArray())
}

fun bytesToHex(bytes: ByteArray): String {
    val hexChars = CharArray(bytes.size * 2)
    for (j in bytes.indices) {
        val v = bytes[j].toInt() and 0xFF

        hexChars[j * 2] = hexArray[v ushr 4]
        hexChars[j * 2 + 1] = hexArray[v and 0x0F]
    }
    return hexChars.concatToString()
}

fun stringToArray(classString: String): Array<String> {
    return classString.split(" ").toTypedArray()
}

fun <T: Element> AttrsScope<T>.classNames(names: String) {
    classes(*stringToArray(names))
}

fun <T: Element> AttrsScope<T>.classList(names: String) { classNames(names) }

fun DateTimeDisplay(d: Instant): String {
    return "%tb %te, %tH:%tM".sprintf(d, d, d, d)
}